import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { PROMETHEAN_NEUTRAL_GREY_700, PROMETHEAN_TEXT, PROMETHEAN_PURPLE_GRAPE, PROMETHEAN_BLUE } from '../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_BODY, PROMETHEAN_TYPOGRAPHY_EYEBROW } from '../styles/typography/typography';
import { styled } from '@mui/system';
import { EmbersMenu } from '../menu';
export var SearchContainer = styled('div')({
  '&.EmbersSearch-root': {
    '.EmbersSearch-bar': {
      height: 32,
      borderRadius: 4,
      display: 'flex',
      width: '100%',
      '.EmbersSearch-input': {
        width: '100%',
        flexGrow: 1,
        '.MuiOutlinedInput-root': {
          input: _objectSpread(_objectSpread({
            padding: '3px 8px 3px 12px',
            height: 24
          }, PROMETHEAN_TYPOGRAPHY_BODY), {}, {
            color: PROMETHEAN_TEXT,
            '::placeholder': {
              color: PROMETHEAN_TEXT,
              opacity: 1
            }
          }),
          '&.Mui-focused': {
            input: {
              '::placeholder': {
                opacity: 0
              }
            }
          }
        },
        '.MuiOutlinedInput-notchedOutline': {
          borderWidth: 0
        }
      },
      '&-rest': {
        border: "1px solid ".concat(PROMETHEAN_NEUTRAL_GREY_700)
      },
      '&-focus': {
        '&-by-click': {
          border: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE)
        },
        '&-by-keyboard': {
          '&-separate': {
            '.EmbersSearch-input': {
              margin: -1,
              '.Mui-focused': {
                input: {
                  padding: '4px 8px 4px 12px'
                }
              },
              '.MuiOutlinedInput-notchedOutline': {
                borderWidth: 2,
                borderRadius: '4px 0px 0px 4px'
              }
            },
            '.MuiButton-sizeSmall': {
              '&.EmbersSearch-clear-btn': {
                borderRadius: 0
              }
            }
          },
          '&-whole': {
            border: "2px solid ".concat(PROMETHEAN_BLUE),
            '.EmbersSearch-input': {
              '.MuiOutlinedInput-root': {
                input: {
                  paddingTop: 2
                }
              }
            }
          },
          '&-focus-menu': {
            border: "1px solid ".concat(PROMETHEAN_PURPLE_GRAPE)
          }
        }
      },
      '.MuiButton-sizeSmall': {
        padding: '3px 6px',
        minWidth: 'auto',
        color: PROMETHEAN_TEXT,
        background: 'transparent',
        '&.Mui-focusVisible': {
          borderRadius: 0,
          outline: "2px solid ".concat(PROMETHEAN_BLUE),
          outlineOffset: -1
        },
        '&.EmbersSearch-search-btn': {
          borderRadius: '0px 3px 3px 0px',
          '&.active': {
            background: PROMETHEAN_PURPLE_GRAPE,
            color: '#FFFFFF'
          },
          '&.Mui-focusVisible': {
            borderRadius: '0px 2px 2px 0px',
            height: 26,
            outlineOffset: 1,
            padding: '1px 4px',
            margin: 2
          }
        },
        '&.EmbersSearch-clear-btn': {
          marginRight: 1
        }
      }
    }
  }
});
export var StyledMenu = styled(EmbersMenu)({
  '&.EmbersPopper-root': {
    '.EmbersSearch-label': {
      '&:hover': {
        background: 'transparent'
      },
      padding: 0,
      p: _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_EYEBROW), {}, {
        textTransform: 'uppercase',
        padding: '8px 16px 6px 16px',
        marginBottom: '-2px'
      })
    }
  }
});